<template>
  <div class="theater-tab">
    <div class="tab-title">
      <img :src="title">
    </div>
    <div class="theater-toolbar">
      <Search
        class="theater-search"
        :filterList="searchFilter"
        gis
        :gisurl="gisurl"
        @search="subminSearch"
        @offsearch="offSearch"
      ></Search>
    </div>

    <m-textArea class="data-list" ref="dataList">
      <div class="video-list">
        <VideoItem
          v-for="(item, index) in datalist"
          :key="index"
          :videoData="item"
          backstage
          @show="$emit('showVidoe', item)"
          @showbehind="$emit('showVideoBehind', item)"
        >
        </VideoItem>
      </div>
      <Pagination
        :num="pageNow"
        :pages="pages"
        @change="chagenPage"
      ></Pagination>
    </m-textArea>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Search from "@/components/Search.vue";
import TextArea from "@/components/TextArea";
import VideoItem from "./VideoItem";
import Pagination from "@/components/Pagination";

export default {
  props: {
    tabData: Object
  },
  components: {
    Search,
    "m-textArea": TextArea,
    VideoItem,
    Pagination
  },
  data() {
    return {
      pageName: "programme",
      onSearch: false,
      searchFilter: [
        { name: "title", title: "剧名" },
        { name: "perfomer", title: "表演人" },
        { name: "actor", title: "演员" },
        { name: "region", title: "地域" },
        { name: "record_place", title: "录制地" },
        { name: "aria", title: "唱腔" },
        { name: "keywords", title: "关键词" },
        { name: "description", title: "简介" }
      ],
      searchParam: {},
      gisurl: "http://amap.zju.edu.cn/maps/3215/mobile"
    };
  },
  computed: {
    ...mapState(["programme"]),
    title() {
      return this.tabData.ttimg;
    },
    datalist() {
      if (this.onSearch) {
        return this.programme.searchres.content;
      }
      return this.programme[this.pageNow];
    },
    pageNow() {
      return this.onSearch
        ? this.programme.searchres.number
        : this.programme.number;
    },
    pages() {
      return this.onSearch
        ? this.programme.searchres.total_pages
        : this.programme.total_pages;
    }
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getDataList", "searchData"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.pageName,
        page_num
      };
      this.getDataList(param);
    },
    chagenPage(num) {
      this.onSearch
        ? this.search(this.searchParam, num)
        : this.getPageData(num);
      this.$refs.dataList.scroll();
    },
    search(param, num = 0) {
      this.searchData({
        data_name: this.pageName,
        page_num: num,
        ...param
      });
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(param) {
      this.search(param);
      this.$refs.dataList.scroll();
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.$refs.dataList.scroll();
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.theater-tab {
  position: relative;
  display: flex;
  height: 72vh;
  flex-direction: column;

  .tab-title {
    position: relative;
    top: 0.5rem;
    height: 5rem;
    margin-bottom: 1rem;
    overflow: hidden;

    img {
      position: relative;
      left: 50%;
      transform: translateX(-50%) scale(0.5);
      transform-origin: center top;
    }

    @media (max-width: 320px) {
      height: 4rem;
      img {
        transform: translateX(-50%) scale(0.4);
      }
    }
  }

  .theater-toolbar {
    position: relative;
    z-index: 2;
    margin-bottom: 1rem;
    .theater-search {
      position: relative;
      @include center-x;
    }
  }

  .data-list {
    height: auto;
    flex: 1;

    .text-main {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      padding-bottom: 1rem;
    }
  }

  .video-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
